import z from "zod";

export const signInReqParams = z.object({
	email: z.string().min(1, "Email is required").email("Must be a valid email"),
	password: z.string(),
});

export type SignInReqParams = z.infer<typeof signInReqParams>;
